module.exports = __webpack_public_path__ + "img/wechat-img5.db949030.png";